import { registerRootComponent } from 'expo';
import App from './App';

// The theme. Metro turns this into the StyleSheet NativeWind reads, so it has to be imported before
// anything renders — on the web it is also the real stylesheet the page uses.
import './global.css';

// registerRootComponent calls AppRegistry.registerComponent, and additionally makes sure the
// environment is set up appropriately whether the app is loaded through Expo Go or a native build.
registerRootComponent(App);
